import type { paths } from "@/api-schema";
import { useDepartmentByUuidQuery } from "@/common/api/department/use-department-by-uuid.query";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { UuidExistenceWrapper } from "@/components/uuid-existence-wrapper/uuid-existence-wrapper";
import { useTranslation } from "react-i18next";
import { useParams } from "wouter";
import { DepartmentFormFields } from "../_components/department-form-fields";

interface UpdateViewParams {
  uuid: string;
}

export function UpdateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const params = useParams<UpdateViewParams>();
  const uuid = params.uuid;

  return (
    <UuidExistenceWrapper<
      paths["/v1/department/{uuid}"]["get"]["parameters"]["query"],
      paths["/v1/department/{uuid}"]["get"]["responses"][200]["content"]["application/json"]
    >
      uuid={uuid}
      query={useDepartmentByUuidQuery}
      notFoundProps={{
        title: t("masterdata:DepartmentNotFound"),
        message: t("masterdata:DepartmentDoesNotExist"),
        description: t("masterdata:PleaseCheckDepartmentIdOrContactSupport"),
        backTo: "~/masterdata/department",
        backToLabel: t("masterdata:BackToDepartmentOverview"),
      }}
    >
      <UpdateViewContent uuid={uuid} />
    </UuidExistenceWrapper>
  );
}

function UpdateViewContent({ uuid }: { uuid: string }) {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:EditDepartment");
  const pageSubtitle = t("common:ReviewAndSaveChangesDescription");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <DepartmentFormFields uuid={uuid} />
    </CenteredLayout>
  );
}
